import { schema } from 'normalizr'
import { Record } from 'immutable'

export const IPGeolocationSchema = new schema.Entity('IPGeolocation', {}, { idAttribute: (data) => data.country })
export const IPGeolocationRecord = Record({
  country: '',
})

export const emptyIPGeolocation = new IPGeolocationRecord()
